<template>
  <div>
    <div class="tabs hide-small">
      <div :class="[ tab === 'main' ? 'active' : '' ]" @click="tab = 'main'">Main details</div>
    </div>
    <div class="tabs tabs-right hide-small">
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(false)">{{ saveOrUpdate }}</div>
      <div :class="[ isValid ? 'valid' : 'disabled', 'save-tab' ]" @click="save(true)">{{ saveOrUpdate }} &amp; exit</div>
    </div>
    <div class="dropdown show-small dropdown-admin-tabs">
      <button class="btn dropdown-toggle" type="button" data-toggle="dropdown">Options
        <span class="caret"></span></button>
      <ul class="dropdown-menu">
        <li @click="tab = 'main'">
          <a href="#">
            Main details
            <i class="fa fa-check-square-o" v-if="tab === 'main'"></i>
          </a>
        </li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(false)"><a href="#">{{ saveOrUpdate }}</a></li>
        <li :class="[ isValid ? 'valid' : 'disabled', 'save-dropdown' ]" @click="save(true)"><a href="#">{{ saveOrUpdate }} &amp; exit</a></li>
      </ul>
    </div>
    <section id="main-content" class="clearfix">
      <div class="clearfix" slot="admin-content" id="location-content">
        <div v-if="tab === 'main'">
          <div class="col-xs-12 col-sm-6 main-location-details left top-small">
            <div class="form-group">
              <label for="calc-code" class="form-label">Code *</label>
              <input type="text" class="form-control" id="calc-code" v-model="entity.code"/>
            </div>
            <div class="form-group">
              <label for="calc-name" class="form-label">Name *</label>
              <input type="text" class="form-control" id="calc-name" v-model="entity.name"/>
            </div>
            <div class="form-group">
              <label for="calc-mu" class="form-label">Measurement Unit</label>
              <select class="form-control" id="calc-mu" v-model="entity.measurementUnit">
                <option value=""></option>
                <option v-for="(opt, i) in dTypes" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
          </div>
          <div class="col-xs-12 col-sm-6 main-location-details left bottom-small">
            <div class="form-group">
              <label for="calc-tu" class="form-label">Time Unit</label>
              <select class="form-control" id="calc-tu" v-model="entity.timeUnit">
                <option value=""></option>
                <option v-for="(opt, i) in uTypes" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
            <div class="form-group">
              <label for="calc-lookup" class="form-label">Lookup</label>
              <auto-complete
                :dataset="lookupSearchResults"
                :placeHolder="'Type to search'"
                :initVal="entity.lookup"
                v-on:changing="data => lookupSearchText = data"
                :fnFormatText="p => `${p.name}`"
                :fnSelectValue="p => `${p.name}`"
                v-on:selection-made="selectLookup"
              ></auto-complete>
            </div>
            <div class="form-group">
              <label for="calc-lookup-type" class="form-label">Lookup type</label>
              <select class="form-control" id="calc-lookup-type" v-model="entity.lookupType">
                <option value=""></option>
                <option v-for="(opt, i) in lTypes" :value="opt.id">{{ opt.name }}</option>
              </select>
            </div>
          </div>
          <div class="col-xs-12">
            <div class="form-group">
              <label for="location-comments" class="form-label">Comments</label>
              <textarea class="form-control" rows="5" id="location-comments" v-model="entity.notes"></textarea>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
  import AdminEntityMixin from '../../mixins/AdminEntityMixin'
  import HelperMixin from '../../mixins/Helpers'
  import AutoComplete from '../../../helpers/AutoComplete.vue'
  import API from '../../../../api/endpoints'
  export default {
    name: 'Calculation',
    mixins: [AdminEntityMixin, HelperMixin],
    components: {
      AutoComplete
    },
    data () {
      return {
        transformForUpdate: {
          lookupType: this.toMinus,
          lookup: this.toMinus,
          measurementUnit: this.toMinus,
          timeUnit: this.toMinus
        },
        newEntityScreen: 'Admin - Calculations',
        editEntityScreen: 'Admin - Edit/View Calculation',
        boxes: [
          {
            prop: 'lookupType',
            id: 'id'
          },
          {
            prop: 'measurementUnit',
            id: 'id'
          },
          {
            prop: 'timeUnit',
            id: 'id'
          }
        ],
        tab: 'main',
        entity: {
          id: null,
          code: null,
          name: null,
          lookupType: null,
          lookup: null,
          measurementUnit: null,
          timeUnit: null,
          notes: null
        },
        lookupType: '',
        measurementUnit: '',
        timeUnit: '',
        entityName: 'calculation',
        lookupSearchResults: [],
        lookupSearchText: ''
      }
    },
    watch: {
      lookupSearchText (newVal, oldVal) {
        if (newVal.trim().length > 1) {
          this.updateLookupSearchResults(newVal)
        } else {
          this.lookupSearchResults = []
        }
      }
    },
    computed: {
      isValid () {
        return this.entity.code && this.entity.name &&
          this.entity.code.trim().length > 0 &&
          this.entity.name.trim().length > 0
      },
      dTypes () {
        return this.filterOptions('DURATION_TYPE')
      },
      uTypes () {
        return this.filterOptions('UNIT_TYPE')
      },
      lTypes () {
        return this.filterOptions('LOOKUP_TYPE')
      }
    },
    methods: {
      selectLookup (lookup) {
        this.lookupSearchResults = []
        this.entity.lookup = lookup
      },
      filterOptions (code) {
        return this.systemOptions.filter(({optionType}) => optionType !== null && optionType.hasOwnProperty('code') && optionType.code === code)
      },
      getBaseData () {
        return {
          id: null,
          code: null,
          name: null,
          lookupType: null,
          lookup: null,
          measurementUnit: null,
          timeUnit: null,
          notes: null
        }
      },
      updateLookupSearchResults (str) {
        this.$http.get(API.GET_ADMIN_ENTITY_BY_FULL_SEARCH('lookup'), {
          params: {
            name: str,
            description: str
          }
        }).then(({data}) => {
          if (str === this.lookupSearchText) {
            this.lookupSearchResults = data
          }
        }).catch(err => console.log(err))
      },
      updateEntity (prop, method, val) {
        this.entity[prop] = this[method](val)
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// Calculation.vue?20113590